import {
  createDetachedSignature,
  createHash,
  type Certificate,
} from 'crypto-pro';

export const getDetachedSignature = async (
  secret: string | ArrayBuffer,
  cert: Certificate
) => {
  const hash = await createHash(secret);
  const sign = await createDetachedSignature(cert.thumbprint, hash);
  return sign;
};
